/* Back to top */
$(window).on('scroll', function() {
  
  if ($(this).scrollTop() > 600) {
    $('.tap-top').fadeIn();
  } else {
    $('.tap-top').fadeOut();
  }
  
});

$('.tap-top').on('click', function() {
  $("html, body").animate({
    scrollTop: 0
  }, 600);
  return false;
});

// Added By Zeian Shahzad -- Custom Product Accordion
document.querySelectorAll('[id^="CustomDetails-"]').forEach((detailsElement) => {
  const summaryElement = detailsElement.querySelector('summary');
  const contentElement = detailsElement.querySelector('.accordion__content');
  
  // Check if the accordion should be open by default (using the 'open' attribute in Liquid or set manually)
  if (detailsElement.hasAttribute('open')) {
    detailsElement.setAttribute('aria-expanded', 'true'); // Set aria-expanded to true when open
  } else {
    detailsElement.setAttribute('aria-expanded', 'false'); // Set aria-expanded to false when closed
  }

  // Add click event listener to toggle open/close and aria-expanded
  summaryElement.addEventListener('click', (event) => {
    event.preventDefault(); // Prevent default behavior to manage toggle manually
    
    const isOpen = detailsElement.hasAttribute('open');
    
    // Toggle the open attribute and aria-expanded
    if (isOpen) {
      detailsElement.removeAttribute('open');
      detailsElement.setAttribute('aria-expanded', 'false');
    } else {
      detailsElement.setAttribute('open', 'true');
      detailsElement.setAttribute('aria-expanded', 'true');
    }
  });
});


/* Top Announcement */
document.addEventListener("DOMContentLoaded", () => {
  class MultiContent {
    constructor(element) {
      this.element = element;
      this.sectionId = element.dataset.sectionId;
      this.autoplay = element.dataset.autoplay === "true";
      this.autoplayDuration = parseInt(element.dataset.autoplayDuration, 10) || 3000;
      this.originalHTML = element.querySelector(".top-announcement-inner").innerHTML;
      this.swiperInstance = null;
      this.init();
    }

    init() {
      this.checkScreenSize();
      window.addEventListener("resize", () => this.checkScreenSize());
    }

    checkScreenSize() {
      const width = window.innerWidth;
      if (width <= 990) { // Enable slider for tablets and mobile
        this.enableSwiper();
      } else {
        this.disableSwiper();
      }
    }

    enableSwiper() {
      if (!this.element.classList.contains("swiper-enabled")) {
        this.element.classList.add("swiper-enabled");
        const innerContainer = this.element.querySelector(".top-announcement-inner");
        const html = this.originalHTML.replaceAll("section__block", "swiper-slide");

        innerContainer.innerHTML = `<div class='swiper-wrapper'>${html}</div>`;

        this.swiperInstance = new Swiper(`.top-announcement-section[data-section-id="${this.sectionId}"] .top-announcement-inner`, {
          loop: true,
          autoplay: this.autoplay ? { delay: this.autoplayDuration, disableOnInteraction: false } : false,
          navigation: {
            nextEl: `.top-announcement-section[data-section-id="${this.sectionId}"] .swiper-button-next`,
            prevEl: `.top-announcement-section[data-section-id="${this.sectionId}"] .swiper-button-prev`,
          },
          breakpoints: {
            0: { slidesPerView: 1 }, // Mobile (0 - 740px)
            741: { slidesPerView: 2 }, // Tablets (741 - 990px)
          },
        });
      }
    }

    disableSwiper() {
      if (this.element.classList.contains("swiper-enabled")) {
        this.element.classList.remove("swiper-enabled");

        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }

        this.element.querySelector(".top-announcement-inner").innerHTML = this.originalHTML;
      }
    }
  }

  // Initialize for all instances
  document.querySelectorAll(".top-announcement-section").forEach((element) => {
    new MultiContent(element);
  });
});

// Main Hightlights 
document.addEventListener("DOMContentLoaded", () => {
  class HighlightSlider {
    constructor(element) {
      this.element = element;
      this.sectionId = element.dataset.sectionId;
      this.autoplay = element.dataset.autoplay === "true";
      this.autoplayDuration = parseInt(element.dataset.autoplayDuration, 10) || 3000;
      this.slidesMobile = parseInt(element.dataset.slidesMobile, 10) || 1; // Get the number of slides for mobile
      this.slidesTablet = parseInt(element.dataset.slidesTablet, 10) || 2; // Get the number of slides for tablet
      this.originalHTML = element.querySelector(".main-highlights-inner").innerHTML;
      this.swiperInstance = null;
      this.init();
    }

    init() {
      this.checkScreenSize();
      window.addEventListener("resize", () => this.checkScreenSize());
    }

    checkScreenSize() {
      const width = window.innerWidth;
      if (width <= 990) { // Enable slider for tablets and mobile
        this.enableSwiper();
      } else {
        this.disableSwiper();
      }
    }

    enableSwiper() {
      if (!this.element.classList.contains("swiper-enabled")) {
        this.element.classList.add("swiper-enabled");
        const innerContainer = this.element.querySelector(".main-highlights-inner");
        const html = this.originalHTML.replaceAll("section__block", "swiper-slide");

        innerContainer.innerHTML = `<div class='swiper-wrapper'>${html}</div>`;

        this.swiperInstance = new Swiper(`.main-highlights[data-section-id="${this.sectionId}"] .main-highlights-inner`, {
          loop: true,
          autoplay: this.autoplay ? { delay: this.autoplayDuration, disableOnInteraction: false } : false,
          navigation: {
            nextEl: `.main-highlights[data-section-id="${this.sectionId}"] .swiper-button-next`,
            prevEl: `.main-highlights[data-section-id="${this.sectionId}"] .swiper-button-prev`,
          },
          pagination: {
            el: `.main-highlights[data-section-id="${this.sectionId}"] .swiper-pagination`, // Element for pagination dots
            clickable: true, // Allow dots to be clickable
          },
          breakpoints: {
            0: { slidesPerView: this.slidesMobile, spaceBetween: 10 }, // Mobile (num of slides based on customizer)
            741: { slidesPerView: this.slidesTablet, spaceBetween: 20 }, // Tablet (num of slides based on customizer)
            991: { slidesPerView: 3, spaceBetween: 10 }, // Desktop (3 slides, centered)
          },
        });
      }
    }

    disableSwiper() {
      if (this.element.classList.contains("swiper-enabled")) {
        this.element.classList.remove("swiper-enabled");

        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }

        this.element.querySelector(".main-highlights-inner").innerHTML = this.originalHTML;
      }
    }
  }

  // Initialize for all instances
  document.querySelectorAll(".main-highlights").forEach((element) => {
    new HighlightSlider(element);
  });
});
